export default "/_next/static/images/ai_edit-9a01bdb98e202274a2e51ae106a7dc1e.png";